import { axiosCreate } from "@config/index"
import { verifyBodyResponse } from "@thelpers/verifyBodyResponse"

export const updateChargeInstanceDebtor = async ({
    token,
    jsonData,
}) => {

    try {
        const res = await axiosCreate.put('/charge/instance/debtor', jsonData, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })

        return verifyBodyResponse(res, true)
    } catch (error) {
        console.error(error)
        return verifyBodyResponse(error, false)
    }
}

/**
 * jsonData:{
    "place_id": 1807,
    "charge_instance_id": 12,
    "debtor_detail": [
        {
            "charge_item_id": 58,
            "total": 3.6
        }
    ]
}
 * 
 */